import { put, takeLatest } from "redux-saga/effects";
import { requestMainAgreementList 
    ,requestCreateMainAgreement, requestUpdateMainAgreement
} from "services/manage-property/property-agreement";

import {
  fetchMainAgreementListRequest,
  fetchMainAgreementListSuccess,
  fetchMainAgreementListFailure,

  createMainAgreementRequest,
  createMainAgreementSuccess,
  createMainAgreementFailure,
  updateMainAgreementRequest,
  updateMainAgreementSuccess,
  updateMainAgreementFailure
} from "../../../../redux/actions/manage-property/property-agreement/agreement-details";

import {
  FETCH_MAIN_AGREEMENT_LIST_REQUEST,
  FETCH_MAIN_AGREEMENT_LIST_SUCCESS,
  FETCH_MAIN_AGREEMENT_LIST_FAILURE,
  CREATE_MAIN_AGREEMENT_REQUEST,
  UPDATE_MAIN_AGREEMENT_REQUEST
} from "../../../../redux/actions/manage-property/property-agreement/types";

export function* watchMainAgreementListSaga() {
  yield takeLatest(FETCH_MAIN_AGREEMENT_LIST_REQUEST, fetchMainAgreement);
  yield takeLatest(CREATE_MAIN_AGREEMENT_REQUEST, createMainAgreement);
  yield takeLatest(UPDATE_MAIN_AGREEMENT_REQUEST, updateMainAgreement);
}

function* fetchMainAgreement({ payload }) {
  try {
    /**
     * @type {FetchBrokerFirmsResponse}
     */
    const response = yield requestMainAgreementList(payload);
    yield put(fetchMainAgreementListSuccess(response));
  } catch (error) {
    yield put(fetchMainAgreementListFailure("Failed to get Main Agreement list"));
  }
}



/**
 *
 * @param {PARAMS} param0
 */
 function* createMainAgreement({ payload }) {
  try {
      const response = yield requestCreateMainAgreement(payload);
      yield put(createMainAgreementSuccess(response.data));
  } catch (error) {
      yield put(
        createMainAgreementFailure('Failed to create Main Agreement')
      );
  }
}

/**
*
* @typedef {Object} BrokerFirmUpdatePayload
* @property {BrokerFirm} payload
*
* @param {BrokerFirmUpdatePayload} param
*/
function* updateMainAgreement({ payload }) {
  try {
    const response = yield requestUpdateMainAgreement(payload);
      yield put(updateMainAgreementSuccess(response.data));
  } catch (error) {
      yield put(
        updateMainAgreementFailure('Failed to update Main Agreement')
      );
  }
}